import ReactGA from 'react-ga4'
import AppConfig, { ENV_TYPES } from 'dpn-common/config/AppConfig'

let GAInitialized = false

function init() {
    if (!AppConfig.GoogleAnalyticsEnabled || !AppConfig.GoogleAnalyticsSiteID) {
        return
    }

    ReactGA.initialize(AppConfig.GoogleAnalyticsSiteID, { debug: AppConfig.environment === ENV_TYPES.Development })
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname + window.location.search })
    GAInitialized = true
}

function setUser(user) {
}

function sendEvent(event) {
    if (!GAInitialized) {
        return
    }

    ReactGA.event(event)
}

function stateChange(newState) {
}

export default {
    init,
    setUser,
    sendEvent,
    stateChange,
}